import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'

import JobsTable from './JobTable'
import { Link } from 'react-router-dom'
import CompanyJobTable from './CompanyJobTable'
import MaintenanceTable from './MaintenanceTable'
import { Card, CardBody } from 'react-bootstrap'
import { API_URL } from '..'

export default function MaintenancePage() {
  const [jobsData , setJobData] = useState([])
  const [active , setActive] = useState(null)
  const [currentUser , setCurrentUser] = useState({})
  const [currentValues, setValues] = useState({
    new:0,
    accept: 0,
    total: 0,
    declined: 0,
    completed: 0,
  });


  const fetchJobsCompany = async ()=>{
    const user = JSON.parse(localStorage.getItem('user'));
    
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let url= "";
       let jsonBody= JSON.stringify({
        "id": user.id
       });
    
        let response = await fetch(`${API_URL}/api/maintenance/records/${user.id}`, { 
            method: "GET",
            headers: headersList
          });
          
          let data = await response.json();
        //   console.log(data)
        
        if(response.status === 200){
            setJobData(data)
            const total  = data.length

            const scheduled = data.filter((item)=>item.resolved_status == false).length;
            const completed = data.filter((item)=>item.resolved_status == true).length;
            setValues({
                total:total,
                new: scheduled,
                accept:0,
                declined: completed
            })
        }
      
       
       
      
  }
  const fetchReports = async ()=>{
    const user = JSON.parse(localStorage.getItem('user'));
    
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let url= "";
       let jsonBody= JSON.stringify({
        "id": user.id
       });
    
        let response = await fetch(`${API_URL}/api/maintenance/issue/records/${user.id}`, { 
            method: "GET",
            headers: headersList
          });
          
          let data = await response.json();
        //   console.log(data)
        if(response.status === 200){
            setValues((prev)=>({
                ...prev,    
                accept: data.length
            }))
            
       
        }
      
       
       
      
  }
useEffect(()=>{
    fetchJobsCompany()
    fetchReports()
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Maintenance Logs" />

        {/* TableDataLayer */}
        <div className="row" style={{columnGap:10}}>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                 <Link>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.total}</h6>
                                    </div>
                                </div>
                             

                            </div>
                            
                        </div>
                    </div>
                 </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                 <Link >
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-info-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Schedule
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.new}</h6>
                                    </div>
                                </div>
                             

                            </div>
                            
                        </div>
                    </div>
                 </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
                   <Link >
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-warning-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                           Reported
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.accept}</h6>
                                    </div>
                                </div>
                               
                            </div>
                          
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
                    <Link>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-success text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Completed
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.declined}</h6>
                                    </div>
                                </div>
                             
                            </div>
                          
                        </div>
                    </div></Link>
                </div>
              
            </div>
            <br></br>
      
        {
         jobsData.length !==0  ?      <MaintenanceTable jobsData={jobsData.reverse()}/>: null 
     

        }
        {
            jobsData.length === 0 ? 
            <Card className="mt-20">
                <CardBody>
                    <p className="text-center">No Maintenance Schedule is created yet. <Link  to={'/schedule-maintenance'} className='text-primary'>Create Schedule</Link></p>
                </CardBody>
            </Card> :null
        }
 
        </MasterLayout>
    </>
  )
}
